import { types } from 'mobx-state-tree';
import { mg } from '../mg/mg';
import { getOmnistore } from './Omnistore';

export const AuthStore = types
	.model('AuthStore', {
		email: '',
		authorization: '',
		role: types.optional(types.enumeration(['STANDARD', 'HARMONIZER', 'ADMIN', 'SUPPLIER']), 'STANDARD'),
		server: '',
		roles: types.array(types.string),
	})
	.actions(self => ({
		sanitize() {
			self.email = self.email.toLowerCase();
			if (!~self.roles.indexOf(self.role)) {
				self.role = 'STANDARD';
				try {
					getOmnistore().locationStore.setPage('GDashboard');
				} catch (e) {
					if (mg.isDevelopment) throw e;
					console.error(e);
				}
			}
		},
	}))
	.actions(self => ({
		setEmail(email: string) {
			self.email = email;
			self.sanitize();
		},
		setAuthorization(authorization: string) {
			self.authorization = authorization;
		},
		setRole(role: typeof self.role) {
			self.role = role;
			self.sanitize();
		},
		setServer(server: string) {
			self.server = server;
		},
		setRoles(roles: ReadonlyArray<string>) {
			self.roles.length = 0;
			self.roles.push(...roles);
			self.sanitize();
		},
	}))
	.views(self => ({
		get roleAsString() {
			return self.role;
		},
		get baseUrl() {
			const s = self.server;
			return (s ? 'https://' + s : mg.isDevelopment ? 'https://local.octopusorder.com' : '');
		},
	}));
